export const log = {
  no: { en: 'No.', ko: '번호', fr: '' },
  msg: { en: 'Message', ko: '메세지', fr: '' },
  msgCode: { en: 'Message Code', ko: '메세지 코드', fr: '' },
  level: { en: 'Level', ko: '레벨', fr: '' },
  uri: { en: 'URI', ko: 'URI', fr: '' },
  userId: { en: 'User ID', ko: '사용자 ID', fr: '' },
  ip: { en: 'IP', ko: 'IP', fr: '' },
  fingerprint: { en: 'Fingerprint', ko: 'Fingerprint', fr: '' },
  recordTime: { en: 'Record time', ko: '기록 시간', fr: '' },
  systemCode: { en: 'System code', ko: '시스템 코드', fr: '' },
  selectLevel: { en: 'Level', ko: '레벨 선택', fr: '' },
  all: { en: 'All', ko: '전체 선택', fr: '' },
  selectSystemCode: { en: 'System Code', ko: '시스템코드 선택', fr: '' },
  searchByMessage: { en: 'search by message', ko: '메세지를 입력하세요.', fr: '' },
  extInfo: { en: 'Extended Information', ko: '추가 정보', fr: '' },
};
